import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CloseDate } from "@/types";

interface CloseDatesState {
  data: CloseDate[];
}

const initialState: CloseDatesState = { data: [] };

const closeDatesSlice = createSlice({
  name: "closeDates",
  initialState,
  reducers: {
    setCloseDates(state, action: PayloadAction<CloseDate[] | null>) {
      state.data = action.payload ?? [];
    },
  },
});

export const { setCloseDates } = closeDatesSlice.actions;
export default closeDatesSlice.reducer;
